var map = {
	"./ALK Breakapart.jpg": 4625,
	"./AML1ETO (RUNX1RUNX1T1) Translocation, Dual Fusion.jpg": 8238,
	"./ATM Deletion.jpg": 8255,
	"./BCL6 Breakapart.jpg": 7488,
	"./BCRABL(ABL1) Plus Translocation, Dual Fusion.jpg": 9107,
	"./D13S319 Plus Deletion.jpg": 8021,
	"./DAPI.jpg": 4198,
	"./Del(5q) Deletion.jpg": 1317,
	"./Del(7q) Deletion.jpg": 3765,
	"./DiGeorge II (10p14).jpg": 6341,
	"./DiGeorgeTBX1 &amp; 22q13.3 Deletion Syndrome Probe.jpg": 72,
	"./DiGeorgeVCFS N25 &amp; 22q13.3 Deletion Syndrome Probe Combination.jpg": 7594,
	"./DiGeorgeVCFS TUPLE1 &amp; 22q13.3 Deletion Syndrome Probe Combination.jpg": 8372,
	"./EVI1 (MECOM) Breakapart.jpg": 8194,
	"./HER2 (ERBB2) Amplification.jpg": 7055,
	"./IGHBCL2 Translocation, Dual Fusion.jpg": 3037,
	"./IGHCCND1 Translocation, Dual Fusion.jpg": 806,
	"./IGHCCND3 Translocation, Dual Fusion.jpg": 4590,
	"./IGHFGFR3 Translocation, Dual Fusion.jpg": 3667,
	"./IGHMAFB Translocation, Dual Fusion.jpg": 3179,
	"./MLL (KMT2A) Breakapart.jpg": 3344,
	"./N-MYC (MYCN) Amplification.jpg": 9942,
	"./P53 (TP53) Deletion.jpg": 3629,
	"./P53 (TP53)ATM Probe Combination.jpg": 1228,
	"./PMLRARα (RARA) Translocation, Dual Fusion.jpg": 6990,
	"./Prader-WilliAngelman (SNRPN).jpg": 7173,
	"./Prenatal X, Y and 18.jpg": 2019,
	"./Prenatal X, Y, 13, 18 and 21.jpg": 3628,
	"./SRY.jpg": 5951,
	"./TCRAD Breakapart.jpg": 6754,
	"./TELAML1 (ETV6RUNX1) Translocation, Dual Fusion.jpg": 5816,
	"./TMPRSS2ERG DeletionBreakapart.jpg": 3822,
	"./activon-tube-advancis.jpg": 5040,
	"./cMYC (MYC) Breakapart.jpg": 1688,
	"./cytocell-logo.jpg": 4482,
	"./dtek-logo.jpg": 8850
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5565;